import { adminHttpClient } from '../../../commons/adminHttpClient'
import { Moment } from 'moment'

export const postBenefitRedesignDecision = (useSame: boolean): Promise<any> => {
  return adminHttpClient.post('/AdminDashboard/Renewal/BenefitRedesign', { useSame })
}
